import { render } from "./DADataTable.vue?vue&type=template&id=f3231380&scoped=true"
import script from "./DADataTable.vue?vue&type=script&lang=js"
export * from "./DADataTable.vue?vue&type=script&lang=js"

import "./DADataTable.vue?vue&type=style&index=0&id=f3231380&lang=scss&scoped=true"

import exportComponent from "../../../../../CASRA/saoil/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3231380"]])

export default __exports__